import { render, staticRenderFns } from "./AddS63.vue?vue&type=template&id=bf9f7b7c&"
import script from "./AddS63.vue?vue&type=script&lang=js&"
export * from "./AddS63.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports